var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSignature = function SvgSignature(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    style: {
      transform: "translate(0, 1px)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/signature"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5863 3C16.4058 3 16.218 3.07222 16.0808 3.20944L14.7593 4.53111L17.4673 7.23944L18.7888 5.91778C19.0704 5.63611 19.0704 5.18111 18.7888 4.89944L17.099 3.20944C16.9546 3.065 16.7741 3 16.5863 3ZM13.9867 5.30389L6 13.2917V16H8.70796L16.6946 8.01222L13.9867 5.30389Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M5 17.4286C5.28283 18.2857 6.27273 20 8.81818 20C11.7879 20 12.2121 17 15.1818 17C17.4735 17 18.1515 17.8571 19 18.7143",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSignature);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "signature.a1d89da2ebe9407e703ab2f0889c473a.svg";